export default "__VITE_ASSET__CPZL7w$0__"